(ns ycweb.app.blitz.hygiene.locationrepair
  (:require
   [rum.core :as rum]
   [ycweb.util.core :as u]
   [ycweb.components.flow :as flow]
   [ycweb.components.forms :as forms]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.feedback :as feedback]
   [ycweb.components.grid :as grid]
   [ycweb.app.blitz.hygiene.screen :as hs]
   [ycweb.components.transitions :as t]
   [ycweb.components.wrapper :as w]
   [ycweb.components.toaster :as toaster]
   [ycweb.util.comms :as comms]
   [ycweb.components.common :as cmn]))

(def steps
  (forms/setup-steps
    [{:key :choose-type :title "Choose action"}
     {:key :start :title "Scan Location to Repair"}
     {:key :zone :title "Choose Zone"}
     {:key :aisle :title "Choose Aisle"}
     {:key :shelf :title "Choose Shelf"}
     {:key :bin :title "Scan Bin"}
     {:key :scan-items :title "Scan Items"}
     {:key :confirm :title "Confirm"}
     {:key :bin-locate :title "Scan Shelf"}
     {:key :done :title "Done"}]))

(defn add-bincolour [k bin]
  (when bin
    (assoc bin :bincolour
      (case (last (get bin k))
        \G :green
        \R :red
        \B :blue
        \Y :yellow
        \C :grey
        :black))))

(rum/defc done-screen < rum/reactive [app-atom]
  (w/wrapper app-atom "Location Repair" {:steps steps :step :done}
    [[:div {:class (u/bem :section [:medium])}
      [:h2.u-text-center {:class (u/bem :heading [:large])} [:b "Thank you!"]]
      [:i.u-block-center {:class (u/bem :icon [:block :enormous :emoticon-happy :3-3])}]
      [:div.u-margin-top-24
       [:p.u-text-center {:class (u/bem :paragraph [:large :flush])}
        [:b "You're all set."]]
       [:p.u-text-center {:class (u/bem :paragraph [:flush])}
        "Location has been repaired."]]]]
    []
    [[:p.u-text-center
      {:class (u/bem :paragraph [:flush :large])}
      [:a.text-link {:on-click #(t/transition-next app-atom :main-menu)} "Done for now"]]
     [:div.call-to-action
      (grid/cell
        {:flush? true}
        (buttons/button
          "Repair Another Location"
          #(t/transition-next app-atom :hygiene/locationrepair)
          {:square-corners true :call-to-action true :large true :full true}))]]))

(defmethod flow/render-screen :hygiene/locationrepair-finish [app-atom]
  (done-screen app-atom))

(defmethod comms/receive :hygiene/locationrepair-bin-locate [app-atom _]
  (toaster/close-subtle-progress app-atom)
  (let [{:keys [shelf aisle fromareas? frombins?]} (get-in @app-atom [:hygiene :locationrepair])]
    (cond
      frombins?
      (grid/dispatch-action app-atom :hygiene/locationrepair-bins shelf)

      fromareas?
      (grid/dispatch-action app-atom :hygiene/locationrepair-shelves aisle)

      :else
      (do
        (swap! app-atom update :hygiene dissoc :locationrepair)
        (t/transition-next app-atom :hygiene/locationrepair-finish)))))

(defmethod grid/action :hygiene/locationrepair-bin-locate [app-atom {:keys [scan]} _]
  (toaster/open-subtle-progress app-atom)
  (comms/send :hygiene/locationrepair-bin-locate
    {:scan scan
     :location (get-in @app-atom [:hygiene :locationrepair :location])}))

(defmethod flow/barcode-dispatch-screen :hygiene/locationrepair-bin-locate [_ app-atom scan]
  (grid/dispatch-action app-atom :hygiene/locationrepair-bin-locate {:scan scan}))

(rum/defc bin-locate < rum/reactive [app-atom]
  (let [current-atom (rum/cursor-in app-atom [:hygiene :locationrepair])
        location (cmn/curact current-atom [:location])]
    (w/wrapper app-atom "Location Repair" {:steps steps :step :bin-locate}
      [[:div.page-body__main-content
        [:div.u-margin-top-24
         {:class (u/bem :section [:medium])}
         [:h2.u-text-center
          {:class (u/bem :heading [:standard])}
          (str "Scan The Shelf That " (:name location) " Is On")]]
        [[:i.u-block-center {:class (u/bem :icon [:enormous :block :barcode-scan :light-force])}]
         [:i.u-block-center {:class (u/bem :icon [:large :block :location :light-force])}]]]]
      nil
      (grid/pos-call-to-action
        {:left-plain true
         :right-text "Scan Shelf"
         :right-plain true}))))

(defmethod flow/render-screen :hygiene/locationrepair-bin-locate [app-atom]
  (bin-locate app-atom))

(defmethod comms/receive :hygiene/locationrepair-finish [app-atom _]
  (toaster/close-subtle-progress app-atom)
  (let [{:keys [frombinfetching? location aisle shelf fromareas? frombins?]} (get-in @app-atom [:hygiene :locationrepair])]
    (cond
      frombinfetching?
      (do
        (swap! app-atom update :hygiene dissoc :locationrepair)
        (grid/dispatch-action app-atom :binfetching/bin-scan
          {:scan (:barcode location)}))

      (= (:location_type location) "bin")
      (t/transition-next app-atom :hygiene/locationrepair-bin-locate)

      frombins?
      (grid/dispatch-action app-atom :hygiene/locationrepair-bins shelf)

      fromareas?
      (grid/dispatch-action app-atom :hygiene/locationrepair-shelves aisle)

      :else
      (do
        (swap! app-atom update :hygiene dissoc :locationrepair)
        (t/transition-next app-atom :hygiene/locationrepair-finish)))))

(defmethod grid/action :hygiene/locationrepair-finish-action [app-atom]
  (toaster/open-subtle-progress app-atom)
  (let [{:keys [items location adjustment-uuid]} (get-in @app-atom [:hygiene :locationrepair])]
    (comms/send :hygiene/locationrepair-finish
      {:scanned-items items
       :location location
       :adjustment-uuid adjustment-uuid})))

(defmethod grid/action :hygiene/locationrepair-item-menu-barcode [app-atom _ _]
  (grid/single-input-modal app-atom
    {:title "Capture manual barcode"
     :field-text "Barcode"
     :initial-value ""
     :save-text "Capture"
     :save-key :hygiene/locationrepair-item-scan
     :input-key :scan
     :input-type :barcode}))

(defmethod grid/action :hygiene/locationrepair-item-unscan [app-atom {:keys [scan]} _]
  (let [items (or (get-in @app-atom [:hygiene :locationrepair :items] []))
        old-item
        (->>
          items
          (filter
            #(and
               (= scan (:barcode %))
               (not (zero? (:qty %)))))
          first)

        new-items
        (->>
          (assoc old-item :qty -1)
          (merge items)
          (group-by :barcode)
          (map
            (fn [[_ l]]
              (reduce #(update %1 :qty + (:qty %2)) l))))]
    (cond
      (not old-item)
      (toaster/open-toast app-atom :error "Barcode can't be unscanned" {})

      :else
      (swap! app-atom assoc-in [:hygiene :locationrepair :items] new-items))))

(defmethod flow/barcode-dispatch-modal :hygiene/locationrepair-item-unscan-modal [_ app-atom scan]
  (grid/dispatch-action app-atom :hygiene/locationrepair-item-unscan {:scan scan})
  (grid/close-modal app-atom))

(defmethod grid/modal-config :hygiene/locationrepair-item-unscan-modal [_ _ _]
  {:body grid/single-input-modal-body
   :footer grid/single-input-modal-footer
   :modal-type :alert})

(defmethod grid/action :hygiene/locationrepair-item-menu-unscan [app-atom _ _]
  (grid/open-modal app-atom :hygiene/locationrepair-item-unscan-modal
    {:scan ""
     :config
     {:title "Unscan Product"
      :field-text "Barcode"
      :initial-value ""
      :save-text "Capture"
      :save-key :hygiene/locationrepair-item-unscan
      :input-key :scan
      :input-type :barcode}}))

(defn item-list-modal [app-atom]
  (grid/menu-modal app-atom
    {:items
     [{:label "Unscan Product"
       :action :hygiene/locationrepair-item-menu-unscan
       :style
       {:full true :large true :negative true
        :icon-left :delete :text-default true :icon-class :3-2}}

      {:label "Manual Barcode"
       :action :hygiene/locationrepair-item-menu-barcode}

      {:label "Cancel"
       :action :hygiene/locationrepair-menu-cancel
       :style
       {:full true :large true :text-link true :on-dark true}}]}))

(rum/defc review-slat < rum/reactive [{:keys [barcode product itemtype qty]}]
  [:article.slat.product-slat.transfer-product-slat
   (cond
     (> qty 0)
     {:class (u/bem :slat [:success])}

     (< qty 0)
     {:class (u/bem :slat [:warning])})
   [:div.product-slat__qty.transfer-product-slat__qty qty]
   [:div.product-slat__info
    [:header.product-slat__header
     [:div.product-slat__title-wrapper
      [:h1.product-slat__title
       [:span.product-slat__brand itemtype]
       product]]]
    [:ul.product-slat__details
     [:li.product-slat__barcode
      [:b.u-text-spaced-1 barcode]]]]])

(rum/defc itemconfirm-screen < rum/reactive [app-atom]
  (let [{:keys [adjustments items location]} (cmn/curact app-atom [:hygiene :locationrepair])
        items (or adjustments items)]
    (w/wrapper app-atom "Location Repair" {:modal-fn item-list-modal :steps steps :step :confirm}
      [[:div
        {:class (u/bem :section [:medium])}
        [:h2.u-text-center
         {:class (u/bem :heading [:standard])}
         (str "Confirm differences in " (:name location))
         [:span.u-hidden-from-view " - "]
         [:span.heading__subtext (str " Count: " (reduce + 0 (map :qty items)))]]]
       [:div.slats
        (map review-slat items)]]
      []
      [[:div.u-margin-top-24
        {:class (u/bem :section [:medium])}
        (feedback/action-feedback :truck "Checked" " the item list?"
          (rum/cursor-in app-atom [:hygiene :locationrepair :location :confirmed]) {})]
       (grid/pos-call-to-action
         {:left-fn #(t/transition-prev app-atom)
          :right-text "Confirm"
          :right-style :call-to-action
          :right-no-icon true
          :right-fn
          (when (cmn/curact app-atom [:hygiene :locationrepair :location :confirmed])
            #(grid/dispatch-action app-atom :hygiene/locationrepair-finish-action {}))})])))

(defmethod flow/render-screen :hygiene/locationrepair-confirm [app-atom]
  (itemconfirm-screen app-atom))

(defmethod comms/receive :hygiene/locationrepair-confirm [app-atom {:keys [adjustment-uuid adjustments]}]
  (toaster/close-subtle-progress app-atom)
  (swap! app-atom update-in [:hygiene :locationrepair] assoc
    :adjustment-uuid adjustment-uuid
    :adjustments adjustments)
  (t/transition-next app-atom :hygiene/locationrepair-confirm))

(defmethod grid/action :hygiene/locationrepair-confirm-action [app-atom _]
  (toaster/open-subtle-progress app-atom)
  (let [{:keys [items location]} (get-in @app-atom [:hygiene :locationrepair])]
    (comms/send :hygiene/locationrepair-confirm
      {:scanned-items items
       :location location})))

(defmethod comms/receive :hygiene/item-lookup [app-atom {:keys [item manual-qty]}]
  (toaster/close-subtle-progress app-atom)
  (let [items (or (get-in @app-atom [:hygiene :locationrepair :items]) [])
        new-items (hs/add-item items item manual-qty)]

    (cond
      (:barcode item)
      (swap! app-atom assoc-in [:hygiene :locationrepair :items] new-items)

      :else
      (toaster/open-toast app-atom :error "Not an item" {}))))

(defmethod grid/action :hygiene/locationrepair-item-scan [app-atom {:keys [scan manual-qty]} _]
  (let [bomitem? (get-in @app-atom [:hygiene :locationrepair :bomitem?])
        scan (or scan (get-in @app-atom [:hygiene :locationrepair :modal-item :barcode]))
        scan (if bomitem? (str scan "/BOM") scan)
        items (get-in @app-atom [:hygiene :locationrepair :items] [])
        existing (first (filter #(= (:barcode %) scan) items))
        new-items (hs/add-item items existing manual-qty)]

    (cond
      existing
      (swap! app-atom assoc-in [:hygiene :locationrepair :items] new-items)

      :else
      (do
        (toaster/open-subtle-progress app-atom)
        (comms/send :hygiene/item-lookup
          {:action :hygiene/item-lookup
           :scan scan
           :manual-qty manual-qty})))))

(defmethod flow/barcode-dispatch-screen :hygiene/locationrepair-items [_ app-atom scan]
  (grid/dispatch-action app-atom :hygiene/locationrepair-item-scan {:scan scan}))

(rum/defc item-slat < rum/reactive [{:keys [barcode product itemtype qty qtyscanned]} {:keys [on-click]}]
  (let [qtyscanned (or qtyscanned 0)]
    (when (pos? qty)
      [:article.slat.product-slat.transfer-product-slat
       (cond
         (= qtyscanned qty)
         {:class (u/bem :slat [:success]) :on-click on-click}

         (pos? qtyscanned)
         {:class (u/bem :slat [:warning]) :on-click on-click}

         :else
         {:on-click on-click})
       [:div.product-slat__qty.transfer-product-slat__qty
        [(if (zero? qty)
           :b.u-text-status-negative
           :b.u-text-status-positive) qty]]
       [:div.product-slat__info
        [:header.product-slat__header
         [:div.product-slat__title-wrapper
          [:h1.product-slat__title
           [:span.product-slat__brand itemtype]
           product]]]
        [:ul.product-slat__details
         [:li.product-slat__barcode
          [:b.u-text-spaced-1 barcode]]]]])))

(defmethod grid/action :hygiene/locationrepair-item-menu-qty [app-atom config _]
  (grid/single-input-modal app-atom
    {:title "Capture manual qty"
     :field-text "Qty"
     :initial-value ""
     :save-text "Capture"
     :save-key :hygiene/locationrepair-item-scan
     :input-key :manual-qty
     :input-type :number}))

(defmethod grid/action :hygiene/locationrepair-item-modal [app-atom item]
  (grid/menu-modal app-atom
    {:items
     [{:label "Manual Qty"
       :action :hygiene/locationrepair-item-menu-qty}

      {:label "Cancel"
       :action :hygiene/locationrepair-menu-cancel
       :style
       {:full true :large true :text-link true :on-dark true}}]})
  (swap! app-atom update-in [:hygiene :locationrepair] assoc
    :modal-item item))

(rum/defc itemscans-screen < rum/reactive [app-atom]
  (let [{:keys [location items]} (cmn/curact app-atom [:hygiene :locationrepair])]
    (w/wrapper app-atom "Location Repair" {:modal-fn item-list-modal :steps steps :step :scan-items}
      [[:div
        {:class (u/bem :section [:medium])}
        [:h2.u-text-center
         {:class (u/bem :heading [:standard])}
         (str "Scan Items in " (:name location))
         [:span.u-hidden-from-view " - "]
         [:span.heading__subtext (str " Count: " (reduce + 0 (map :qty items)))]]]
       [:div.slats
        (map
          (fn [i]
            (item-slat i
              {:on-click
               #(grid/dispatch-action app-atom
                  :hygiene/locationrepair-item-modal i)}))
          items)]]
      [[:p.u-text-center
        {:class (u/bem :paragraph [:flush :large])}
        "Press Next to Continue"]]
      (grid/pos-call-to-action
        {:left-fn #(t/transition-prev app-atom nil)
         :right-fn #(grid/dispatch-action app-atom :hygiene/locationrepair-confirm-action {})}))))

(defmethod flow/render-screen :hygiene/locationrepair-items [app-atom]
  (itemscans-screen app-atom))

(defmethod comms/receive :hygiene/location-lookup [app-atom {:keys [location bomitem?]}]
  (toaster/close-subtle-progress app-atom)
  (swap! app-atom update-in [:hygiene :locationrepair] assoc
    :bomitem? bomitem?
    :items []
    :frombinfetching? false
    :location location)
  (t/transition-next app-atom :hygiene/locationrepair-items))

(defmethod grid/action :hygiene/location-lookup [app-atom {:keys [scan]} _]
  (toaster/open-subtle-progress app-atom)
  (comms/send :hygiene/location-lookup
    {:scan scan}))

(defmethod flow/barcode-dispatch-screen :hygiene/locationrepair [_ app-atom scan]
  (grid/dispatch-action app-atom :hygiene/location-lookup {:scan scan}))

(rum/defc locationrepair < rum/reactive [app-atom]
  (w/wrapper app-atom "Location Repair" {:steps steps :step :start}
    [[:div.page-body__main-content
      [:div.u-margin-top-24
       {:class (u/bem :section [:medium])}
       [:h2.u-text-center
        {:class (u/bem :heading [:standard])}
        "Scan Location to Repair"]]
      [[:i.u-block-center {:class (u/bem :icon [:enormous :block :barcode-scan :light-force])}]
       [:i.u-block-center {:class (u/bem :icon [:large :block :location :light-force])}]]]]
    []
    (grid/pos-call-to-action
      {:left-fn #(grid/dispatch-action app-atom :hygiene/menu {})
       :right-text "Scan Location"
       :right-plain true})))

(defmethod flow/render-screen :hygiene/locationrepair [app-atom]
  (locationrepair app-atom))

(defmethod grid/action :hygiene/locationrepair [app-atom _ _]
  (swap! app-atom update-in [:hygiene :locationrepair] assoc
    :fromareas? false
    :frombins? false)
  (t/transition-next app-atom :hygiene/locationrepair))

(defmethod flow/barcode-dispatch-screen :hygiene/locationrepair-bins [_ app-atom scan]
  (grid/dispatch-action app-atom :hygiene/location-lookup {:scan scan}))

(defmethod comms/receive :hygiene/locationrepair-bins-missing [app-atom _]
  (toaster/close-subtle-progress app-atom)
  (let [{:keys [aisle]} (get-in @app-atom [:hygiene :locationrepair])]
    (grid/dispatch-action app-atom :hygiene/locationrepair-shelves
      [[(:aisle aisle) (:aisleid aisle)]])))

(defmethod grid/action :hygiene/locationrepair-bins-missing [app-atom _ _]
  (toaster/open-subtle-progress app-atom)
  (let [bins (get-in @app-atom [:hygiene :locationrepair :bins])]
    (comms/send :hygiene/locationrepair-bins-missing
      {:bins bins})))

(defmethod grid/action :hygiene/locationrepair-bins-missing-confirm [app-atom _ _]
  (grid/confirm-modal app-atom
    {:title "Confirm bins are missing?"
     :text "This will mark the bins and all of their items as lost."
     :confirm-key :hygiene/locationrepair-bins-missing}))

(defn bin-list-modal [app-atom]
  (grid/menu-modal app-atom
    {:items
     [{:label "Can't find remaning bins"
       :action :hygiene/locationrepair-bins-missing-confirm}

      {:label "Cancel"
       :action :hygiene/locationrepair-menu-cancel
       :style
       {:full true :large true :text-link true :on-dark true}}]}))

(rum/defc bin-slat < rum/reactive [bin]
  (let [slat-color :neutral]
    [:article.slat-wrapper
     [:div.picking-slat
      {:class (u/bem :slat [slat-color])}
      [:div.picking-slat__graphic-wrapper
       [:div.picking-slat__icon-wrapper
        [:i {:class (u/bem :icon [:2-2 :block :location])}]]]
      [:div.picking-slat__info
       [:h3
        {:class (u/bem :pill [:large :picking-bin (:bincolour bin)])} (:name bin)]]]]))

(rum/defc bin < rum/reactive [app-atom]
  (let [{:keys [bins shelf aisle]} (cmn/curact app-atom [:hygiene :locationrepair])]
    (w/wrapper app-atom "Location Repair" {:modal-fn bin-list-modal :steps steps :step :bin}
      [[:div.section
        [:h2.u-text-center
         {:class (u/bem :heading [:standard])}
         (str "Scan Bin on " (:name shelf))
         [:span.u-hidden-from-view " - "]
         [:span.heading__subtext (str "Bins: " (count bins))]]]

       [:div.slats
        (map
          (fn [i]
            (bin-slat i))
          (map (partial add-bincolour :name) bins))]]
      []
      (grid/pos-call-to-action
        {:left-fn #(grid/dispatch-action app-atom :hygiene/locationrepair-shelves aisle)
         :right-plain true}))))

(defmethod flow/render-screen :hygiene/locationrepair-bins [app-atom _]
  (bin app-atom))

(defmethod grid/action :hygiene/locationrepair-bins [app-atom [shelf bins]]
  (swap! app-atom update-in [:hygiene :locationrepair] assoc
    :shelf shelf
    :bins bins)
  (t/transition-next app-atom :hygiene/locationrepair-bins))

(defmethod comms/receive :hygiene/locationrepair-bins [app-atom {:keys [bins]}]
  (toaster/close-subtle-progress app-atom)
  (swap! app-atom update-in [:hygiene :locationrepair] assoc
    :bins bins)
  (t/transition-next app-atom :hygiene/locationrepair-bins))

(defmethod grid/action :hygiene/locationrepair-bins [app-atom shelf]
  (swap! app-atom update-in [:hygiene :locationrepair] assoc
    :shelf shelf
    :frombins? true)
  (toaster/open-subtle-progress app-atom)
  (comms/send :hygiene/locationrepair-bins {:shelfid (:id shelf)}))

(defmethod flow/barcode-dispatch-screen :hygiene/locationrepair-shelves [_ app-atom scan]
  (grid/dispatch-action app-atom :hygiene/location-lookup {:scan scan}))

(rum/defc shelf-slat < rum/reactive [[shelf data] {:keys [on-click]}]
  (let [slat-color :neutral
        hasbins? (not (nil? (:bin (first data))))]
    [:article.slat-wrapper
     [:div.picking-slat
      {:class (u/bem :slat [slat-color]) :on-click (when hasbins? on-click)}
      [:div.picking-slat__graphic-wrapper
       [:div.picking-slat__icon-wrapper
        [:i {:class (u/bem :icon [:2-2 :block :location])}]]]
      [:div.picking-slat__info
       [:h3
        {:class (u/bem :picking-slat__title [:large])}
        (if hasbins?
          (str shelf " (" (count data) ")")
          (str shelf " (N/A)"))]]]]))

(rum/defc location-slat < rum/reactive [location location-count-idx {:keys [on-click]}]
  (let [slat-color :neutral
        bin-count (or (get location-count-idx (:id location)) 0)]
    [:article.slat-wrapper
     [:div.picking-slat
      {:class (u/bem :slat [slat-color]) :on-click (when (pos? bin-count) on-click)}
      [:div.picking-slat__graphic-wrapper
       [:span.picking-slat__icon-wrapper
        [:i {:class (u/bem :icon [:block :2-2 :location])}]]]
      [:div.picking-slat__info
       [:h3
        {:class (u/bem :picking-slat__title [:large])}
        (str (:name location) " (" bin-count ")")]]]]))

(rum/defc shelf-list < rum/reactive [app-atom]
  (let [{:keys [aisle zone shelves bin-count bin-count-idx]} (cmn/curact app-atom [:hygiene :locationrepair])]
    (w/wrapper app-atom "Location Repair" {:steps steps :step :shelf}
      [[:div.section
        [:h2.u-text-center
         {:class (u/bem :heading [:standard])}
         (str "Choose Shelf in " (:name aisle))
         [:span.u-hidden-from-view " - "]
         [:span.heading__subtext (str "Shelves: " (count shelves))]
         [:span.heading__subtext (str "Bins: " bin-count)]]]

       [:div.slats
        (map
          (fn [location]
            (rum/with-key
              (location-slat location bin-count-idx
                {:on-click
                 #(grid/dispatch-action app-atom :hygiene/locationrepair-bins location)})
              (:id location)))
          shelves)]]
      []
      (grid/pos-call-to-action
        {:left-fn #(grid/dispatch-action app-atom :hygiene/locationrepair-aisles zone)
         :right-plain true}))))

(defmethod flow/render-screen :hygiene/locationrepair-shelves [app-atom _]
  (shelf-list app-atom))

(defmethod comms/receive :hygiene/locationrepair-shelves [app-atom {:keys [shelves bin-count-idx bin-count]}]
  (toaster/close-subtle-progress app-atom)
  (swap! app-atom update-in [:hygiene :locationrepair] assoc
    :shelves shelves
    :bin-count-idx bin-count-idx
    :bin-count bin-count)

  (t/transition-next app-atom :hygiene/locationrepair-shelves))

(defmethod grid/action :hygiene/locationrepair-shelves [app-atom aisle]
  (swap! app-atom update-in [:hygiene :locationrepair] assoc
    :aisle aisle
    :aisleid (:id aisle)
    :frombins? false
    :fromareas? true)
  (toaster/open-subtle-progress app-atom)
  (comms/send :hygiene/locationrepair-shelves {:aisleid (:id aisle)}))

(rum/defc aisle-list < rum/reactive [app-atom]
  (let [{:keys [aisles zone shelf-count shelf-count-idx]} (cmn/curact app-atom [:hygiene :locationrepair])]
    (w/wrapper app-atom "Location Repair" {:steps steps :step :aisle}
      [[:div.section
        [:h2.u-text-center
         {:class (u/bem :heading [:standard])}
         (str "Choose Aisle in " (:name zone))
         [:span.u-hidden-from-view " - "]
         [:span.heading__subtext (str "Aisles: " (count aisles))]
         [:span.heading__subtext (str "Shelves: " shelf-count)]]]
       [:div.slats
        (map
          (fn [location]
            (rum/with-key
              (location-slat location shelf-count-idx
                {:on-click
                 #(grid/dispatch-action app-atom :hygiene/locationrepair-shelves location)})
              (:id location)))
          aisles)]]
      []
      (grid/pos-call-to-action
        {:left-fn #(grid/dispatch-action app-atom :hygiene/locationrepair-zones {})
         :right-plain true}))))

(defmethod flow/render-screen :hygiene/locationrepair-aisles [app-atom _]
  (aisle-list app-atom))

(defmethod comms/receive :hygiene/locationrepair-aisles [app-atom {:keys [aisles shelf-count shelf-count-idx]}]
  (toaster/close-subtle-progress app-atom)
  (swap! app-atom update-in [:hygiene :locationrepair] assoc
    :aisles aisles
    :shelf-count shelf-count
    :shelf-count-idx shelf-count-idx)
  (t/transition-next app-atom :hygiene/locationrepair-aisles))

(defmethod grid/action :hygiene/locationrepair-aisles [app-atom zone]
  (toaster/open-subtle-progress app-atom)
  (swap! app-atom update-in [:hygiene :locationrepair] assoc
    :zone zone)
  (comms/send :hygiene/locationrepair-aisles {:zoneid (:id zone)}))

(defmethod comms/receive :hygiene/locationrepair-close-stocktake [app-atom _]
  (toaster/close-subtle-progress app-atom)
  (t/transition-next app-atom :main-menu))

(defmethod grid/action :hygiene/locationrepair-close-stocktake [app-atom _ _]
  (toaster/open-subtle-progress app-atom)
  (comms/send :hygiene/locationrepair-close-stocktake
    {:stocktake-id (get-in @app-atom [:hygiene :locationrepair :stocktake :id])}))

(defmethod grid/action :hygiene/menu-locationrepair-close-stocktake [app-atom _ _]
  (grid/confirm-modal app-atom
    {:title "Close Stocktake"
     :text
     [:p {:class (u/bem :paragraph [:flush])}
      "Are you sure you want to close the current stocktake?"]
     :confirm-key :hygiene/locationrepair-close-stocktake
     :confirm-text "Yes" :icon-left :delete :icon-class :3-2 :negative true}))

(defmethod comms/receive :hygiene/locationrepair-start-stocktake [app-atom {:keys [stocktake]}]
  (toaster/close-subtle-progress app-atom)
  (swap! app-atom assoc-in [:hygiene :locationrepair :stocktake] stocktake))

(defmethod grid/action :hygiene/locationrepair-start-stocktake [app-atom _ _]
  (toaster/open-subtle-progress app-atom)
  (comms/send :hygiene/locationrepair-start-stocktake {}))

(defn zone-list-modal [app-atom]
  (grid/menu-modal app-atom
    {:items
     [{:label "Start Stocktake"
       :action :hygiene/locationrepair-start-stocktake}

      {:label "Close Stocktake"
       :action :hygiene/menu-locationrepair-close-stocktake
       :style
       {:full true :large true :negative true
        :icon-left :delete :text-default true :icon-class :3-2}}

      {:label "Cancel"
       :action :hygiene/locationrepair-menu-cancel
       :style
       {:full true :large true :text-link true :on-dark true}}]}))

(rum/defc zone-list < rum/reactive [app-atom]
  (let [{:keys [zones zone-count aisle-count shelf-count bin-count stocktake aisle-count-idx shelf-total bin-total shelf-percent]}
        (cmn/curact app-atom [:hygiene :locationrepair])]
    (w/wrapper app-atom "Location Repair" {:modal-fn zone-list-modal :steps steps :step :zone}
      [[:div.section
        [:h2.u-text-center
         {:class (u/bem :heading [:standard])}
         "Choose Zone"
         [:span.u-hidden-from-view " - "]
         [:span.heading__subtext (str "Zones: " zone-count)]
         [:span.heading__subtext (str "Aisles: " aisle-count)]
         [:span.heading__subtext (str "Shelves: " shelf-count " / " shelf-total ", " shelf-percent "% complete")]
         [:span.heading__subtext (str "Bins: " bin-count " / " bin-total)]
         [:span.heading__subtext (str "Stocktake: " (:dateadded stocktake))]]]
       [:div.slats
        [[:div.slats
          (map
            (fn [zone]
              (rum/with-key
                (location-slat zone aisle-count-idx
                  {:on-click
                   #(grid/dispatch-action app-atom :hygiene/locationrepair-aisles zone)})
                (:id zone)))
            zones)]]]]
      []
      (grid/pos-call-to-action
        {:left-fn #(t/transition-prev app-atom)
         :right-plain true}))))

(defmethod flow/render-screen :hygiene/locationrepair-zones [app-atom _]
  (zone-list app-atom))

(defmethod comms/receive :hygiene/locationrepair-zones
  [app-atom {:keys [aisle-count-idx zones zone-count aisle-count shelf-count bin-count stocktake shelf-total bin-total shelf-percent]}]
  (toaster/close-subtle-progress app-atom)
  (swap! app-atom update-in [:hygiene :locationrepair] assoc
    :zones zones
    :zone-count zone-count
    :aisle-count-idx aisle-count-idx
    :aisle-count aisle-count
    :shelf-count shelf-count
    :shelf-total shelf-total
    :shelf-percent shelf-percent
    :bin-count bin-count
    :bin-total bin-total
    :stocktake stocktake)
  (t/transition-next app-atom :hygiene/locationrepair-zones))

(defmethod grid/action :hygiene/locationrepair-zones [app-atom _]
  (toaster/open-subtle-progress app-atom)
  (comms/send :hygiene/locationrepair-zones {}))

(rum/defc choose-type < rum/reactive [app-atom]
  (w/wrapper app-atom "Location Repair" {:steps steps :step :choose-type}
    [[:div.section
      [:h2.u-text-center
       {:class (u/bem :heading [:standard])}
       "What would you like to do?"]
      [:a.card.tile.u-angled-background.u-bg-teal-blue.u-min-height-160
       {:on-click
        #(grid/dispatch-action app-atom :hygiene/locationrepair-zones {})}
       [:span.tile__content
        [:span.tile__icon-wrapper
         [:i.tile__icon
          {:class (u/bem :icon [:2-2 :stocktake :large :block])}]]
        [:span.tile__text "Repair List"]]]
      [:a.card.or-card.tile.u-angled-background.u-bg-deep-purple.u-min-height-160
       {:on-click
        #(grid/dispatch-action app-atom :hygiene/locationrepair {})}
       [:span.tile__content
        [:span.tile__icon-wrapper
         [:i.tile__icon
          {:class (u/bem :icon [:2-2 :barcode-scan :large :block])}]]
        [:span.tile__text "Scan Location"]]]]]
    []
    (grid/pos-call-to-action
      {:left-fn #(t/transition-prev app-atom)
       :right-plain true})))

(defmethod flow/render-screen :hygiene/locationrepair-choose-type [app-atom _]
  (choose-type app-atom))